import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { IKImage } from "imagekitio-react";

const SevenDayTrial = ({ countDownDate }) => {
  const [isCardEnabled, setIsCardEnabled] = useState(false);
  const navigate = useNavigate();
  const [isTimerOn, setIsTimerOn] = useState(false);
  const [time, setTime] = useState({});
  const timerRef = useRef(null);


  useEffect(() => {
    timerRef.current = setInterval(function () {
      const now = Date.now();
      const timeleft = countDownDate - now;
      const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      const hours = Math.floor(timeleft / (1000 * 60 * 60));
      const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
      if (hours < 0 && minutes < 0 && seconds < 0) {
        setIsCardEnabled(false);
        setIsTimerOn(false);
      } else {
        setIsTimerOn(true);
      }

      setTime({ d: days, h: hours, m: minutes, s: seconds });
      if (timeleft < 0) {
        clearInterval(timerRef.current);
      }
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [countDownDate]);


  return (
    isTimerOn && (
      <div className="mt-3 md:mt-1 relative cursor-pointer mr-2">
        <div className="flex flex-col" onClick={(e) => setIsCardEnabled(!isCardEnabled)}>
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={
              "https://assets.learntube.ai/files/homepage-banner/timer.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1669658770054"
            }
            transformation={[
              {
                height: "110",
                width: "110",
              },
            ]}
            className="-mb-4 md:-mb-8 h-[35px] w-[35px] md:h-[55px] md:w-[55px] lg:h-[45px] lg:w-[45px]"
          />
          <div className="flex flex-col -mt-3 md:-mt-[8px] lg:-mt-1 items-center justify-center text-[#E06064] ">
            <div className="text-[10px] md:text-[12px] font-bold">
              {time.d === 0
                ? time.h === 0
                  ? time.m === 0
                    ? time.s
                    : time.m
                  : time.h
                : time.d + 1}
            </div>
            <div className="-mt-[5px] md:-mt-[6px] text-[8px] md:text-[10px] font-medium">
              {time.d === 0
                ? time.h === 0
                  ? time.m === 0
                    ? "Secs"
                    : "Mins"
                  : "Hrs"
                : "Days"}
            </div>
          </div>
        </div>

        {isCardEnabled && (
          <div
            className="absolute -left-[60px] top-[55px] z-[9999] flex w-40 flex-col items-center justify-center rounded-lg border-2 bg-white py-2 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.56)] md:-left-[50px] lg:-left-[55px] "
            onMouseLeave={(e) => setIsCardEnabled(false)}
          >
            <div className="h-4 w-4 -translate-y-[17px] rotate-45 transform border-l-2 border-t-2 bg-white shadow-xl"></div>
            <span className="-mt-2 text-center text-xs font-medium ">
              Your LearnTube Max trial ends in {time.d === 0
                ? time.h === 0
                  ? time.m === 0
                    ? time.s
                    : time.m
                  : time.h
                : time.d + 1} {time.d === 0
                  ? time.h === 0
                    ? time.m === 0
                      ? "Secs"
                      : "Mins"
                    : "Hrs"
                  : "Days"}
            </span>
            <button
              className="mt-2 rounded-md bg-[#F59E0B] py-1 px-3 text-xs font-medium"
              onClick={(e) => navigate("/pricing")}
            >
              Unlock all Access
            </button>
          </div>
        )}
      </div>
    )
  );
};

export default SevenDayTrial;
